import gql from 'graphql-tag';

export const UPDATE_MERCHANT_ACCOUNT_DETAILS = gql`
  mutation updateMerchantAccountDetails($params: AccountDetailsInput!) {
    updateMerchantAccountDetails(params: $params) {
      success
      response {
        id
      }
    }
  }
`;
export const GET_ACCOUNT_INFORMATION = gql`
  query GetAccountInformation(
    $params: GetAccountDetailsInput!
    $paymentParams: PaymentInput!
    $campaignParams: CampaignFindByInput!
  ) {
    getAccountDetails(params: $params) {
      merchantUuid
      companyName
      title
      firstName
      lastName
      email
      category
      subCategory
      pointOfSaleSystem
      address1
      address2
      city
      state
      postal
      phone
      latitude
      longitude
      numberOfStores
    }

    paymentDetails(params: $paymentParams) {
      merchantCustomerProfile {
        merchantCustomerProfileId
        merchantCustomerId
        budgetPlan {
          renewalTargetCents
        }
        preferredPaymentInstrument {
          preferred
          type
          properties {
            accountType
            accountNickname
            last4Digits
          }
        }
      }

      allRenewals
    }

    campaignFindBy(params: $campaignParams) {
      campaign {
        name
        startDate
        endDate
      }
      budgets {
        totalBudget
        uuid
        balance
      }
    }
  }
`;

export default GET_ACCOUNT_INFORMATION;
